export default {
    error: false,
    validated: false,
    params :{
        file: null,
        validated:false
    },
    loading: {
        module:false,
    },
    message_loading : 'Cargando Plantilla De Incorporación De Clientes',
};



// WEBPACK FOOTER //
// ./src/modules/import-accounts-plans/state.js